import { Paw } from "@/components/Paw";

const PawInitial = ({ letter, className = "" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <ellipse cx="12" cy="28" rx="7" ry="9.5" transform="rotate(-20 12 28)" />
    <ellipse cx="25" cy="15" rx="6.5" ry="9.5" />
    <ellipse cx="39" cy="15" rx="6.5" ry="9.5" />
    <ellipse cx="52" cy="28" rx="7" ry="9.5" transform="rotate(20 52 28)" />
    <path d="M32 28C19 28 12.5 39 15.5 48.5C18.3 57.3 26 60 32 60C38 60 45.7 57.3 48.5 48.5C51.5 39 45 28 32 28Z" />
    <text x="32" y="52" textAnchor="middle" fontSize="21" fontWeight="800" fill="#F6EDDF" fontFamily="'Baloo 2', cursive">{letter}</text>
  </svg>
);

export const HoundNote = ({ message, author = "George", className = "" }) => {
  const initials = author.split("&").map((s) => s.trim()[0]).filter(Boolean);
  return (
    <div
      data-testid={`hound-note-${author.toLowerCase().replace(/[^a-z]/g, "-")}`}
      className={`relative flex flex-col gap-3 max-w-xl rounded-[1.75rem] bg-subtle border border-rosegold/25 px-7 py-6 shadow-[0_8px_30px_rgba(110,30,36,0.06)] ${className}`}
    >
      <span className="absolute -top-3 left-7 bg-maroon text-cream text-[10px] uppercase tracking-widest px-3 py-1 rounded-full flex items-center gap-1.5">
        <Paw className="w-3 h-3" />
        A note from {author}
      </span>
      <p className="text-inkbrown/85 leading-relaxed italic pt-1">"{message}"</p>
      <div className="self-end flex items-center gap-2 -mb-1">
        <span className="font-bubble font-bold text-maroon text-lg">— {author}</span>
        <span className="flex items-center gap-1 text-maroon">
          {initials.map((l, i) => (
            <PawInitial key={i} letter={l} className="w-8 h-8 -rotate-12" />
          ))}
        </span>
      </div>
    </div>
  );
};
